import { Route, Routes } from 'react-router-dom';
import DocumentPreviewPage from './Show/DocumentPreviewPage';
import { DocumentStorageContextTemplate } from '.';

const DocumentsRouter = () => {
  return (
    <DocumentStorageContextTemplate>
      <Routes>
        <Route path=":documentName" element={<DocumentPreviewPage />} />
      </Routes>
    </DocumentStorageContextTemplate>
  );
};

DocumentsRouter.getRouterPath = () => '/documents/*';

export default DocumentsRouter;
